import PortalLayout from '@/layout/Portal'
import { Role } from './roles'

export default [{
  path: '/portal/:portalId',
  component: PortalLayout,
  props: { basePath: '/portal' },
  redirect: '/portal/:portalId/podsumowanie',
  meta: {
    auth: true,
    authorize: [Role.Admin, Role.Redactor]
  },
  children: [
    // dashboard
    {
      path: 'podsumowanie',
      component: () => import('@/components/dashboard/Portal'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'reklamy',
      component: () => import('@/components/placements'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    // statystyki
    {
      path: 'statystyki',
      component: () => import('@/components/statistics/Index'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    // artykuły
    {
      path: 'artykuly',
      component: () => import('@/components/articles/List'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'artykuly/ai',
      component: () => import('@/components/articles/AiList'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'newsroom',
      redirect: 'newsroom/zrodla',
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'newsroom/zrodla',
      component: () => import('@/components/newsroom/Sources'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'newsroom/zrodla/dodaj',
      component: () => import('@/components/newsroom/SourceAdd'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'newsroom/ziarna',
      component: () => import('@/components/newsroom/Seeds'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'newsroom/autogenerowanie',
      component: () => import('@/components/newsroom/Autogeneration'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'newsroom/powiadomienia',
      component: () => import('@/components/newsroom/Notifications'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'artykuly/nowy',
      component: () => import('@/components/articles/New'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'artykuly/kategorie',
      component: () => import('@/components/articles/categories/List'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'artykuly/kategorie/nowa',
      component: () => import('@/components/articles/categories/New'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'artykuly/kategorie/:id',
      component: () => import('@/components/articles/categories/Edit'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'artykuly/:id',
      component: () => import('@/components/articles/Edit'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    // komentarze
    {
      path: 'komentarze',
      component: () => import('@/components/comments/List'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'komentarze/:articleId',
      component: () => import('@/components/comments/List'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    // ogłoszenia
    {
      path: 'ogloszenia',
      component: () => import('@/components/classifieds/List'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'ogloszenia/kategorie',
      component: () => import('@/components/classifieds/categories/List'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'ogloszenia/kategorie/nowa',
      component: () => import('@/components/classifieds/categories/New'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'ogloszenia/kategorie/:id',
      component: () => import('@/components/classifieds/categories/Edit'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'ogloszenia/:id',
      component: () => import('@/components/classifieds/Edit'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    // layout
    {
      path: 'wyglad/szablon',
      component: () => import('@/components/layout/builder/index'),
      meta: {
        authorize: [Role.Admin]
      }
    },
    // podstrony
    {
      path: 'podstrony',
      component: () => import('@/components/single-pages/List'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'podstrony/nowa',
      component: () => import('@/components/single-pages/New'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'podstrony/:id',
      component: () => import('@/components/single-pages/Edit'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    // ustawienia
    {
      path: 'ustawienia',
      component: () => import('@/components/settings/index'),
      meta: {
        authorize: [Role.Admin]
      }
    },
    {
      path: 'ustawienia/smtp',
      component: () => import('@/components/settings/smtp'),
      meta: {
        authorize: [Role.Admin]
      }
    },
    //slownik
    {
      path: 'slownik',
      component: () => import('@/components/dictionary/List'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'slownik/nowy',
      component: () => import('@/components/dictionary/New'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'slownik/:id',
      component: () => import('@/components/dictionary/Edit'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    // materialy
    {
      path: 'materialy-uzytkownikow',
      component: () => import('@/components/userMaterials/List'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'materialy-uzytkownikow/:id',
      component: () => import('@/components/userMaterials/Edit'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    // przekierowania
    {
      path: 'przekierowania',
      component: () => import('@/components/redirects/List'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'przekierowania/nowe',
      component: () => import('@/components/redirects/New'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'przekierowania/:id',
      component: () => import('@/components/redirects/Edit'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    // newsletter
    {
      path: 'newsletter',
      component: () => import('@/components/newsletter/List'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'newsletter/kategorie',
      component: () => import('@/components/newsletter/CategoriesList'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'newsletter/kategorie/dodaj',
      component: () => import('@/components/newsletter/CategoriesManage'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'newsletter/kategorie/:id',
      component: () => import('@/components/newsletter/CategoriesManage'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'newsletter/dodaj',
      component: () => import('@/components/newsletter/Manage'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'newsletter/:id',
      component: () => import('@/components/newsletter/Manage'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    }
  ]
}]
